import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconSavings(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
        <g transform="matrix(0.0486524,0,0,0.0486524,4.37498,4.375)">
          <path d="M460.809,0L273.076,0C268.55,0.001 264.21,1.8 261.01,5.001L5.01,261.001C-1.659,267.662 -1.665,278.468 4.997,285.137L192.743,472.883C199.408,479.545 210.211,479.545 216.875,472.883L472.875,216.883C476.08,213.679 477.879,209.332 477.876,204.8L477.876,17.067C477.876,7.641 470.235,0 460.809,0ZM22.003,273.075L204.809,455.881L457.322,203.368L457.322,20.554L274.525,20.554L22.003,273.075Z" />
        </g>
        <g transform="matrix(0.0486524,0,0,0.0486524,4.37498,4.375)">
          <path d="M358.409,174.154C388.612,174.154 413.096,149.67 413.096,119.467C413.096,89.264 388.612,64.78 358.409,64.78C328.206,64.78 303.722,89.264 303.722,119.467C303.722,149.67 328.206,174.154 358.409,174.154ZM358.409,153.6C339.558,153.6 324.276,138.318 324.276,119.467C324.276,100.616 339.558,85.334 358.409,85.334C377.26,85.334 392.542,100.616 392.542,119.467C392.542,138.318 377.26,153.6 358.409,153.6Z" />
        </g>
      </g>
    </Icon>
  )
}
